import MatchDetailsTeamA from "./MatchDetailsTeamA.jsx"
import MatchDetailsTeamB from "./MatchDetailsTeamB.jsx"

export default function MatchEnded({match, bet, groupId}) {
  return (
    <div className="flex flex-row items-center justify-center space-x-4">
      <MatchDetailsTeamA match={match} />

      <div className="p-2">
        <div className="flex flex-row" key={"form-" + groupId + "|" + match.id} id={groupId + "|" + match.id}>
          <span className={`${match.team_a_score > match.team_b_score ? "font-bold" : ""}`}>{match.team_a_score}</span>
          <div className="flex px-2 items-center justify-center">x</div>
          <span className={`${match.team_a_score < match.team_b_score ? "font-bold" : ""}`}>{match.team_b_score}</span>
        </div>
      </div>

      <MatchDetailsTeamB match={match} />
    </div>
  )
}
